import React from 'react';
import PropTypes from 'prop-types';
import Table from '../base/Table/BootstrapTable';
import TableColumn from '../base/Table/BootstrapTableColumn';

const ProductResultTable = (props) => {
    return(
        <div className="col-xs-12">
            <Table
                data= {props.products}
                keyField="id"
                pageChanged={props.onPageChanged}
                selectedIndex={props.selectedIndex}
                selectedPage={props.selectedPage}
                selectedRowChanged = {props.selectedRowChanged}> 
                <TableColumn
                    dataField="code"
                    label="Kod"
                    width = "50%"/>
                <TableColumn
                    dataField="name"
                    label="Nazwa"
                    width = "40%"/>
            </Table>
        </div>
    );
};


ProductResultTable.propTypes = {
    products: PropTypes.array,
    onPageChanged: PropTypes.func,
    selectedIndex: PropTypes.number,
    selectedPage: PropTypes.number,
    selectedRowChanged: PropTypes.func
};

export default ProductResultTable;


// WEBPACK FOOTER //
// ./src/components/Product/ProductResultTable.js